import axios from "axios";
// import Vue from "vue";
import store from "../store/index";
import router from "../router/index.js";
import common from "../../util/common"
import cryptUtil from '../../util/cryptUtil.js'

let base =
  // process.env.NODE_ENV == "production" ? "http://dev.client-api.ksaxshop.com" : "" // 开发
  // process.env.NODE_ENV == "production" ? "http://test.client-api.ksaxshop.com" : "" // 测试
  process.env.NODE_ENV == "production" ? "http://client-api.ksaxshop.com" : "" // 生产

// 请求延时
axios.defaults.timeout = 5 * 60 * 1000

var storeTemp = store

// 配置请求拦截器
axios.interceptors.request.use(
  config => {
    // if( localStorage.getItem('token') ){
    //   config.headers.Authorization = localStorage.getItem('token')
    // }
    var curTime = new Date()
    var appKey = global.appKey
    var appSecret = global.appSecret
    var timeStamp = curTime.getTime() // 时间戳
    var nonce = common.createRandomCode(10)
    var signature = common.sign(appKey, appSecret, timeStamp, nonce) //签名
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))
    // if(storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.Authorization = "Bearer " + storeTemp.state.token
    config.headers.appKey = appKey
    config.headers.timeStamp = timeStamp
    config.headers.nonce = nonce
    config.headers.signature = signature
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
)
// http 响应拦截器
axios.interceptors.response.use(
  response => {
    const { data: { code } } = response
    if (code === 'nologin') {
      ToLogin()
    } else {
      // 对响应数据做处理
      return response;
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          router.push({
            path: '/login'
          })
          ToLogin()
      }
    }
    return Promise.reject(error);
  }
)

const ToLogin = (params) => {
  store.commit("saveToken", "")
  store.commit("saveTokenExpire", "")
  store.commit("saveTagsData", "")
  // window.localStorage.removeItem("user")
  // window.localStorage.removeItem("NavigationBar")

  // if (global.IS_IDS4) {
  //   applicationUserManager.login()
  // } else {
  router.replace({
    path: "/login",
    query: {
      redirect: router.currentRoute.fullPath
    },
  })

  //   window.location.reload()
  // }
}
export const GetQiniuToken = (params) => {
  return axios.get(`${base}/api/Upload/GetQiniuToken`, { params: params })
}
export const userInfo = (params) => {
  return axios.get(`${base}/api/Member/Home`, { params: params })
}
// 获取短信验证码
export const GetMobileVerifyCode = (params) => {
  return axios.get(`${base}/api/VerifyCode/GetMobileVerifyCode`, { params: params })
}
export const GetTestVerifyCode = (params) => {
  return axios.get(`${base}/api/VerifyCode/GetTestVerifyCode`, { params: params })
}
// 经销商注册
export const DealerRegister = (params) => {
  return axios.post(`${base}/api/Account/DealerRegister`, params)
}
// 刷新token
export const getUserByToken = (params) => {
  return axios.get(`${base}/api/Account/RefreshToken`, {
    params: params
  }).then((res) => res.data)
}
// 登录
export const requestLogin = (params) => {
  return axios.get(`${base}/api/Account/PwdLogin`, { params: params }).then((res) => res.data)
}
// 广告图
export const GetRecommendBannerlist = (params) => {
  return axios.get(`${base}/api/Recommend/GetRecommendBannerlist`, { params: params })
}
// 省市区地址
export const AreaList = (params) => {
  return axios.get(`${base}/api/Area/List`, { params: params })
}
// 收货地址
export const AddressAdd = (params) => {
  return axios.post(`${base}/api/Address/Add`, params)
}
export const AddressDelete = (params) => {
  return axios.post(`${base}/api/Address/Delete`, params)
}
export const AddressUpdate = (params) => {
  return axios.post(`${base}/api/Address/Update`, params)
}
export const AddressList = (params) => {
  return axios.get(`${base}/api/Address/List`, { params: params })
}
// 爆款推荐
export const GetRecommendProductListBussiness = (params) => {
  return axios.post(`${base}/api/Recommend/GetRecommendProductListBussiness`, params)
}
// 热卖品牌
export const NaviDetail = (params) => {
  return axios.get(`${base}/api/ProductNavi/NaviDetail`, { params: params })
}
// 商品分类列表
export const BusinessNaviSpuList = (params) => {
  return axios.get(`${base}/api/ProductSpu/BusinessNaviSpuList`, { params: params }).then(res => {
    res.data.response.data.forEach(item => {
      if (item.EncryptPriceInfo) {
        let encryptPriceInfo = cryptUtil.decrypt(item.EncryptPriceInfo)
        for (var key in encryptPriceInfo) {
          item[key] = encryptPriceInfo[key]
        }
      }
      item.Skus.forEach(sku => {
        if (sku.EncryptPriceInfo) {
          let skuEncryptPriceInfo = cryptUtil.decrypt(sku.EncryptPriceInfo)
          for (var key in skuEncryptPriceInfo) {
            sku[key] = skuEncryptPriceInfo[key]
          }
        }
      })
    })
    return Promise.resolve(res)
  })
}
// 商品详情
export const BusinessDetail = (params) => {
  return axios.get(`${base}/api/ProductSpu/BusinessDetail`, { params: params })
}
// 商品详情推荐商品列表
export const BusinessSpuDetailRecommend = (params) => {
  return axios.get(`${base}/api/ProductSpu/BusinessSpuDetailRecommend`, { params: params })
}
// 添加购物车
export const ShoppingCartAdd = (params) => {
  return axios.post(`${base}/api/ShoppingCart/Add`, params)
}
// 购物车列表
export const ShoppingCartList = (params) => {
  return axios.get(`${base}/api/ShoppingCart/List`, { params: params })
}
// 购物车数量设置
export const ShoppingCartSet = (params) => {
  return axios.post(`${base}/api/ShoppingCart/Set`, params)
}
// 购物车勾选
export const ShoppingCartSelect = (params) => {
  return axios.post(`${base}/api/ShoppingCart/Select`, params)
}
export const ShoppingCartRemove = (params) => {
  return axios.post(`${base}/api/ShoppingCart/Remove`, params)
}
// 订单结算
export const ShoppingCartSettleList = (params) => {
  return axios.get(`${base}/api/ShoppingCart/SettleList`, { params: params })
}
export const CreateOrder = (params) => {
  return axios.post(`${base}/api/UserOrder/Create`, params)
}
// 奖金账户详情
export const BonusAccount = (params) => {
  return axios.get(`${base}/api/Account/BonusAccount`, { params: params })
}
export const WalletPay = (params) => {
  return axios.post(`${base}/api/UserOrder/WalletPay`, params)
}
// 立即购买列表
export const DirectSettleList = (params) => {
  return axios.get(`${base}/api/ShoppingCart/DirectSettleList`, { params: params })
}
// 商品分类
export const ProductNaviList = (params) => {
  return axios.get(`${base}/api/ProductNavi/List`, { params: params })
}
export const BusinessBrandTypeData = (params) => {
  return axios.get(`${base}/api/ProductSpu/BusinessBrandTypeData`, { params: params })
}
// 订单列表
export const UserOrderList = (params) => {
  return axios.get(`${base}/api/UserOrder/List`, { params: params })
}
// 订单详情
export const UserOrderDetail = (params) => {
  return axios.get(`${base}/api/UserOrder/Detail`, { params: params })
}
// 取消订单
export const UserOrderCancel = (params) => {
  return axios.post(`${base}/api/UserOrder/Cancel`, params)
}
// 订单物流信息
export const UserOrderLogistics = (params) => {
  return axios.get(`${base}/api/UserOrder/Logistics`, { params: params })
}
// 售后订单列表
export const UserAfterSaleList = (params) => {
  return axios.get(`${base}/api/UserAfterSale/List`, { params: params })
}
// 确认收货
export const UserOrderReceipt = (params) => {
  return axios.post(`${base}/api/UserOrder/Receipt`, params)
}
// 申请退款
export const UserAfterSaleApplyRefund = (params) => {
  return axios.post(`${base}/api/UserAfterSale/ApplyRefund`, params)
}
export const UserAfterSaleApplyChange = (params) => {
  return axios.post(`${base}/api/UserAfterSale/ApplyChange`, params)
}
export const UserAfterSaleApplyReturn = (params) => {
  return axios.post(`${base}/api/UserAfterSale/ApplyReturn`, params)
}


export const GetOrderList = (params) => {
  return axios.post(`${base}/api/Business_UserManager/GetOrderList`, params)
}
export const GetDeliveryList = (params) => {
  return axios.get(`${base}/api/Business_UserManager/AllList`, { params: params })
}
export const GetLogisticsByNumber = (params) => {
  return axios.get(`${base}/api/Business_UserManager/GetLogisticsByNumber`, { params: params })
}
export const ChildSupShip = (params) => {
  return axios.post(`${base}/api/Business_UserManager/ChildSupShip`, params)
}
export const OrderLogisticsImport = (params) => {
  return axios.post(`${base}/api/Business_UserManager/OrderLogisticsImport`, params)
}

